/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".container[_ngcontent-%COMP%]{height:100%;overflow:hidden}.list-container[_ngcontent-%COMP%]{height:200px;overflow:auto}.common-button-wrapper[_ngcontent-%COMP%]{padding-left:2px}.common-button[_ngcontent-%COMP%]{width:100%}"];
export { styles as styles };
